type Props = { kind: "inventory" | "supplier" | "safety" };

export function ModalLoadingSkeleton({ kind }: Props) {
  const rows = kind === "safety" ? 4 : 6;
  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
        <div style={{ height: 24, width: 120, background: "var(--surface-2)", borderRadius: 4 }} />
        <div style={{ height: 24, width: 240, background: "var(--surface-2)", borderRadius: 4 }} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            style={{
              height: 32,
              background: "var(--surface-2)",
              borderRadius: 4,
              opacity: 0.6 - i * 0.05,
            }}
          />
        ))}
      </div>
    </div>
  );
}
